import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { CiSearch } from "react-icons/ci";
import { useParams } from "react-router-dom";
import { Form, Table } from "react-bootstrap";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { studyOnboardingService } from "../../../../APIServices/studyOnboarding";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import SplitPane from "react-split-pane";
import Pagination from "../../../Pagination";
import UseToggle from "../../../../Hooks/UseToggle";
import UpdateStudyKitBatchNumberMetadata from "./UpdateStudyKitBatchNumberMetadata";
import AddNewStudyKitBatchNumberMetadata from "./AddNewStudyKitBatchNumberMetadata";
import DeletedStudyKitBatchNumberMetadata from "./DeletedStudyKitBatchNumberMetadata";
import StudyKitBatchNumberMetadataActivities from "./StudyKitBatchNumberMetadataActivities";
import { eiwrsKitBatchNumberServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitBatchNumberServices";

const StudyKitBatchNumberMetadataDataList = ({ onMouseDown, tableRef }) => {
  let { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2 } = UseToggle();
  const [searchData, setSearchData] = useState("");
  const [kitBatchNumberData, setKitBatchNumberData] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [kitBatchNumberList, setKitBatchNumberList] = useState([]);
  const [kitBatchNumberCount, setKitBatchNumberCount] = useState(0);
  const [deletedStudySiteKitBatchNumber, setDeletedStudyKitBatchNumber] = useState([]);
  const [deletedStudySiteKitBatchNumberCount, setDeletedStudyKitBatchNumberCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("activities");
  const [kitBatchNumberId, setKitBatchNumberId] = useState("");
  const [activityLoader, setActivityLoader] = useState(false);
  const [kitBatchNumberActivity, setKitBatchNumberActivity] = useState([]);
  const [kitBatchNumberActivityCount, setKitBatchNumberActivityCount] = useState(0);
  const [tableColumns, setTableColumns] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(kitBatchNumberCount / itemsPerPage);

  const getEIWRSKitBatchNumberMetadataData = async (e) => {
    setLoading(true);
    let data = await eiwrsKitBatchNumberServices.getEIWRSKitBatchNumberMetadataData(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setKitBatchNumberList(data?.data || []);
    setKitBatchNumberCount(data?.count || 0);
    setLoading(false);
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedEIWRSKitBatchNumberMetadataData = async (
    pageNumberDeleted,
    itemsPerPageDeleted
  ) => {
    let data = await eiwrsKitBatchNumberServices.getEIWRSKitBatchNumberMetadataData(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedStudyKitBatchNumber(data?.data || []);
    setDeletedStudyKitBatchNumberCount(data?.count || 0);
  };

  const getStudyAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyAuditTrials(
      "EIWRSKitBatchNumberMetadata",
      studyId,
      kitBatchNumberData?.batchId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setKitBatchNumberActivity(data?.data || []);
    setKitBatchNumberActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  useEffect(() => {
    setActiveTab("activities");
  }, [kitBatchNumberData]);

  useEffect(() => {
    getEIWRSKitBatchNumberMetadataData();
  }, [searchData, pageNumber, itemsPerPage]);

  const softDeleteRestoreEIWRSKitBatchNumberMetadata = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} Site Kit Batch Number!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.id = id;
        userData.type = type;
        let data =
          await eiwrsKitBatchNumberServices.softDeleteRestoreEIWRSKitBatchNumberMetadata(
            userData
          );
        if (data?.statusCode === 200) {
          getEIWRSKitBatchNumberMetadataData();
          setKitBatchNumberId("");
          getDeletedEIWRSKitBatchNumberMetadataData();
          if (type === "restore") {
            getDeletedEIWRSKitBatchNumberMetadataData(pageNumberDeleted, itemsPerPageDeleted);
            setToggle1();
          }
        }
      }
    });
  };

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add New"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setKitBatchNumberId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {kitBatchNumberCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 250, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          {StudyMode === "DBP Mode" &&
            deletedStudySiteKitBatchNumberCount > 0 &&
            <button
              onClick={() => {
                setToggle1();
                getDeletedEIWRSKitBatchNumberMetadataData(
                  pageNumberDeleted,
                  itemsPerPageDeleted
                );
              }}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          }
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={kitBatchNumberId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewStudyKitBatchNumberMetadata getEIWRSKitBatchNumberMetadataData={getEIWRSKitBatchNumberMetadataData} />
          )}
          {loading ? (
            <PageLoader />
          ) : kitBatchNumberCount === 0 ? (
            <NoDataFoundTable MSG={"Study Kit Batch Number not found!"} />
          ) : kitBatchNumberList?.length === 0 ? (
            <NoDataFoundTable MSG={"Search Study Kit Batch Number not found!"} />
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>
                      Batch Number
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 2)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Edit
                    </th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 3)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {kitBatchNumberList?.map((kitBatchNumberData, index) => (
                    <tr
                      key={index}
                      title="View Details"
                      className={`${kitBatchNumberId === kitBatchNumberData?._id ? "highlighted" : ""
                        }`}
                      onClick={() => setIsFormOpen(false)}
                    >
                      <td
                        onClick={() => {
                          setKitBatchNumberData(kitBatchNumberData);
                          setKitBatchNumberId(kitBatchNumberData?._id);
                        }}
                        className="text-center"
                      >
                        {index + 1 + startIndex}.
                      </td>
                      <td
                        onClick={() => {
                          setKitBatchNumberData(kitBatchNumberData);
                          setKitBatchNumberId(kitBatchNumberData?._id);
                        }}
                      >
                        {kitBatchNumberData?.batchNumber}
                      </td>
                      <td
                        className="text-center CP"
                        title={`Update ${kitBatchNumberData?.kitBatchNumber}`}
                        onClick={(e) => {
                          setKitBatchNumberData(kitBatchNumberData);
                          setToggle();
                          e.stopPropagation();
                        }}
                        style={{ pointerEvents: "auto" }}
                      >
                        <FaEdit className="text-muted" />
                      </td>
                      <td
                        className="text-center CP"
                        title={`Delete ${kitBatchNumberData?.kitBatchNumber}`}
                        onClick={(e) => {
                          softDeleteRestoreEIWRSKitBatchNumberMetadata(
                            kitBatchNumberData?._id,
                            "delete"
                          );
                        }}
                      >
                        <FaTrash className={"text-danger"} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={kitBatchNumberCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {kitBatchNumberId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map(
                  (tab) => (
                    <button
                      key={tab}
                      className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                        }`}
                      onClick={() => setActiveTab(tab)}
                      title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                    >
                      {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                  )
                )}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setKitBatchNumberId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={toggleFullScreen}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <StudyKitBatchNumberMetadataActivities
                onMouseDown={onMouseDown}
                tableRef={tableRef}
                kitBatchNumberActivity={kitBatchNumberActivity}
                activityLoader={activityLoader}
                getStudyAuditTrials={getStudyAuditTrials}
                kitBatchNumberData={kitBatchNumberData}
                kitBatchNumberActivityCount={kitBatchNumberActivityCount}
                isFullScreen={isFullScreen}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateStudyKitBatchNumberMetadata
        Show={!toggle}
        Hide={setToggle}
        kitBatchNumberData={kitBatchNumberData}
        setKitBatchNumberId={setKitBatchNumberId}
        getEIWRSKitBatchNumberMetadataData={getEIWRSKitBatchNumberMetadataData}
        Title={"Update Batch Number"}
      />
      <DeletedStudyKitBatchNumberMetadata
        Show={!toggle1}
        Hide={setToggle1}
        setKitBatchNumberId={setKitBatchNumberId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedStudySiteKitBatchNumber={deletedStudySiteKitBatchNumber}
        getDeletedEIWRSKitBatchNumberMetadataData={getDeletedEIWRSKitBatchNumberMetadataData}
        deletedStudySiteKitBatchNumberCount={deletedStudySiteKitBatchNumberCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreEIWRSKitBatchNumberMetadata={softDeleteRestoreEIWRSKitBatchNumberMetadata}
        Title={"Deleted Study Site Batch Number History"}
      />
    </>
  );
};

export default StudyKitBatchNumberMetadataDataList;
